require('./bootstrap');

import { createInertiaApp } from '@inertiajs/vue2';
import Vue from 'vue';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';
import 'animate.css/animate.min.css';
//import "cropperjs/dist/cropper.css";
import '../css/app.css';
import '../css/glassmorphic-elements.css';
import Vuetify from 'vuetify/lib';

// Pin _grid utilities (.flex etc.) to win the cascade
// TODO - fix all instancves of .flex and .col instances and repair to avoid
import 'vuetify/src/components/VGrid/_grid.sass';

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

//import VueSignaturePad from "vue-signature-pad";
import { VueMasonryPlugin } from 'vue-masonry';
import VCurrencyField from 'v-currency-field';
import Trend from 'vuetrend';
import LoadScript from 'vue-plugin-load-script';
import VueCropper from 'vue-cropperjs';
import VueDOMPurifyHTML from 'vue-dompurify-html';

import { VTextField } from 'vuetify/lib';
import VueApexCharts from 'vue-apexcharts';
import { router } from '@inertiajs/vue2';

import { datadogRum } from '@datadog/browser-rum';

import axios from 'axios';

window.moment = moment;

if (window.Laravel.production) {
    const ignoreList = [];

    if (!ignoreList.includes(window.Laravel.user?.email) && window.Laravel) {
        datadogRum.init({
            applicationId: 'c9e41979-e70c-45e9-ba76-5ebd569c9c7d',
            clientToken: 'pube5aa28c305fecef7121e15d7e17cf155',
            site: 'us5.datadoghq.com',
            service: 'soli',
            env: 'production',
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            defaultPrivacyLevel: 'allow',
        });

        datadogRum.setUser({
            id: window.Laravel.user?.id,
            name: window.Laravel.user?.name,
            email: window.Laravel.user?.email,
            session_id: window.Laravel.session_id,
            role: window.Laravel.role ?? '',
        });
    }
}

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'ebe655cc5d53796e8813',
    cluster: 'us2',
    forceTLS: true,
});

Vue.use(LoadScript);
Vue.use(Trend);
//Vue.use(VueSignaturePad);
Vue.use(VueMasonryPlugin);
Vue.use(VueApexCharts);
Vue.component(VueCropper);
Vue.use(VueDOMPurifyHTML);

Vue.component('v-text-field', VTextField);
Vue.component('apexchart', VueApexCharts);

Vue.use(VCurrencyField, {
    locale: 'en',
    decimalLength: 2,
    autoDecimalMode: true,
    /*min: null,
    max: null,
    defaultValue: 0,*/
    valueAsInteger: false,
    allowNegative: false,
});

//Vue.use(plugin);

Vue.mixin({ methods: { route } });

function prefersDarkMode(source = window.Laravel.theme) {
    if (source === 'light') return false;
    if (source === 'dark') return true;
    if (source === 'system') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
}

// Global methods
Vue.mixin({
    methods: {
        can(permission) {
            if (!this.$page.props.auth.user) return null;
            return this.$page.props.auth.permissions.includes(permission);
        },
        is(role) {
            if (!this.$page.props.auth.user) return null;
            return this.$page.props.auth.roles.includes(role);
        },
        closeModal(method, timeout = 300) {
            if (!method) return;
            setTimeout(() => {
                method();
            }, timeout);
        },
        throttle(method, wait = 300) {
            let throttled = false;
            return function (...args) {
                if (!throttled) {
                    method(args);
                    throttled = true;
                    setTimeout(() => {
                        throttled = false;
                    }, wait);
                }
            };
        },
        debounce(method, wait = 300) {
            let timer;
            return function (value, cancel = false) {
                if (cancel) {
                    clearTimeout(timer);
                    return;
                }
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    method(value);
                }, wait);
            };
        },
        formatUnitAmount(value) {
            return this.formatCurrency(value / 100);
        },
        formatCurrency(value) {
            return `$${Number(value).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
        },
        prefersDarkMode() {
            return prefersDarkMode(this.$page?.props?.auth?.user?.theme ?? null);
        },
        setDarkMode(override = null) {
            const value = override ?? this.prefersDarkMode();
            document.documentElement.classList.toggle('dark', value);
            document.documentElement.style.colorScheme = value ? 'dark' : 'light';
            this.$vuetify.theme.dark = value;
            const metaTags = document.querySelectorAll('meta[name="theme-color"]');
            metaTags.forEach((tag) => {
                tag.setAttribute(
                    'content',
                    value ? this.$vuetify.theme.themes.dark.background : this.$vuetify.theme.themes.light.background
                );
                tag.removeAttribute('media');
            });
        },
        /*sessionHelper(key, value = null) {
            this.$inertia.post(
                "/session",
                { key, value },
                {
                    preserveState: true,
                    preserveScroll: true,
                }
            );
        },*/
    },
});
//Vue.use(PortalVue);
Vue.use(Vuetify);

Vue.prototype.$log = console.log;
Vue.prototype.$table = console.table;

Vue.prototype.moment = moment;

const darkMode = prefersDarkMode();

document.documentElement.classList.toggle('dark', darkMode);
document.documentElement.style.colorScheme = darkMode ? 'dark' : 'light';
const metaTags = document.querySelectorAll('meta[name="theme-color"]');
metaTags.forEach((tag) => {
    tag.setAttribute('content', darkMode ? '#19202a' : '#fdfdfd');
    tag.removeAttribute('media');
});

createInertiaApp({
    title: (title) => `${title ? title + ' | ' : ''}Musicologie`,
    resolve: (name) => import(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin);
        let vue = new Vue({
            vuetify: new Vuetify({
                icons: {
                    iconfont: 'md',
                },
                theme: {
                    options: {
                        customProperties: true,
                    },
                    dark: darkMode,
                    themes: {
                        light: {
                            background: '#f5f5f7',
                            surface: '#fcfcfc',
                            primary: '#2aabe6',
                            secondary: '#f38c68',
                            accent: '#228cbd',
                            deep: '#2772a0',
                            //success: "#48ad24",
                            success: '#32c090',
                            error: '#b71c1c',
                            dark: '#4b6876',
                            warning: '#fbbd23',
                            'soli-green': '#48ad24',
                            'soli-red': '#e07b7b',
                            dim: '#e5e7eb',
                            contrast: '#3a5260',
                            'contrast-secondary': '#ddd',
                            status: '#228cbd',
                            'ai-orange': '#fbbd23',
                            'ai-purple': '#a64ddc',
                            'status-group': '#69c0c6',
                            'status-green': '#32c090',
                            'status-blue': '#7bb1e0',
                            'status-red': '#e07b7b',
                        },
                        dark: {
                            background: '#19202a',
                            surface: '#1d242f',
                            primary: '#2aabe6',
                            secondary: '#f38c68',
                            accent: '#228cbd',
                            deep: '#216691',
                            //success: "#48ad24",
                            success: '#32c090',
                            error: '#b71c1c',
                            dark: '#4b6876',
                            warning: '#fbbd23',
                            'soli-green': '#48ad24',
                            'soli-red': '#e07b7b',
                            dim: '#e5e7eb',
                            contrast: '#f2f2f2',
                            'contrast-secondary': '#797979',
                            status: '#185876',
                            'ai-orange': '#d79900',
                            'ai-purple': '#9b34d8',
                            'status-group': '#4d9094',
                            'status-green': '#26936e',
                            'status-blue': '#638fb6',
                            'status-red': '#ad5d5d',
                        },
                        soli: {
                            background: '#228cbd',
                            primary: '#f2f2f2',
                            secondary: '#f2f2f2',
                            text: '#f2f2f2',
                        },
                    },
                },
            }),
            data: {
                networkError: false,
                loading: false,
            },
            created() {
                this.channels = initChannels(props.props.initialPage.props);
            },
            render: (h) => h(App, props),
        }).$mount(el);
        document.addEventListener('inertia:exception', (event) => {
            vue.networkError = true;
        });
        router.on('start', (event) => {
            vue.loading = true;
        });
        router.on('finish', (event) => {
            vue.loading = false;
        });
        // Force full page reload on browser back/forward
        window.addEventListener('popstate', function (event) {
            if (!event.state) return;
            if (vue.loading) return;
            router.reload({ preserveScroll: false, preserveState: false });
        });
    },
});

// more performance, but requires babel for safari it seems
/*const baseComponents = require.context(
    "@/Components/Base",
    true,
    /\.vue$/,
    "lazy"
);

for (const file of baseComponents.keys()) {
    const name = file
        .replace(/index.js/, "")
        .replace(/^\.\//, "")
        .replace(/\.\w+$/, "");
    const componentName = upperFirst(camelCase(name));

    Vue.component(componentName, () =>
        baseComponents(file).then((m) => m.default || m)
    );
}*/

const requireComponent = require.context('@/Components/Base', true, /\.vue$/);

for (const file of requireComponent.keys()) {
    const componentConfig = requireComponent(file);
    const name = file
        .replace(/index.js/, '')
        .replace(/^\.\//, '')
        .replace(/\.\w+$/, '');
    const componentName = upperFirst(camelCase(name));

    Vue.component(`${componentName}`, componentConfig.default || componentConfig);
}

const initChannels = (props) => {
    const authUser = props.auth?.user;
    if (!authUser) return {};

    const crmMode = props.crmMode;
    const lobbyId = authUser.selected_location.user?.id;
    const authId = authUser.id;

    return {
        auth: window.Echo.private(`App.Models.User.${authId}`),
        lobby: crmMode && lobbyId ? window.Echo.private(`App.Models.User.${lobbyId}`) : null,
    };
};
